module.exports = __webpack_public_path__ + "img/eye-doctor1.1c15a0ae.jpg";